var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 9,
    viewBox: "0 0 13 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3607 7.09344C12.3607 3.93935 9.59022 1.36066 6.50006 1.36066C3.4099 1.36066 0.639404 3.91803 0.639404 7.09344C0.639404 7.32787 0.660716 7.54098 0.682027 7.7541H12.3181C12.3394 7.54098 12.3607 7.32787 12.3607 7.09344Z",
    stroke: "#00E194"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.75415H13",
    stroke: "#00E194"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1474 8.18038C12.1474 8.30825 12.0409 8.39349 11.9343 8.39349H1.29991C1.17204 8.39349 1.08679 8.28694 1.08679 8.18038V7.96727C1.08679 7.8394 1.19335 7.75415 1.29991 7.75415H11.9343C12.0622 7.75415 12.1474 7.86071 12.1474 7.96727V8.18038Z",
    stroke: "#00E194"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71143 1.38195C5.71143 0.891785 6.09503 0.508179 6.5852 0.508179C7.07536 0.508179 7.45897 0.891785 7.45897 1.38195",
    stroke: "#00E194"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76062 3.34265C10.9328 4.21642 11.7213 5.6656 11.7213 7.28527",
    stroke: "#00E194"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC8);
export default __webpack_public_path__ + "static/media/c8.afaf8adfd7a26754390d6ea1d8ff61f7.svg";
export { ForwardRef as ReactComponent };